/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import { createSelector } from '@reduxjs/toolkit';
import { getInitiativeGroupTree, getInitiativeGroupFlatTree } from './initiativeTree';
import { InitiativeType } from '../types/initiative';
import { AppIds } from '../utils/permission-groups';
import { SettingStorage } from '../services/SettingStorage';

export const getFirstInitiativeGroupId = createSelector(
  [
    (state) => state.initiative.data,
    getInitiativeGroupFlatTree,
    getInitiativeGroupTree
  ],
  (initiativeData, initiatives, reportingLevelTree) => {
    const rootInitiativeId = SettingStorage.getItem(AppIds.PortfolioTracker);

    const id = initiativeData?._id;
    if (id && initiatives.some(d => d._id === id && d.type === InitiativeType.initiativeGroup)) {
      return id
    }

    // Look for It first
    if (rootInitiativeId && reportingLevelTree.children?.some(d => d.id === rootInitiativeId)) {
      return rootInitiativeId;
    }

    const childId = reportingLevelTree.children?.find(d => d.type === InitiativeType.initiativeGroup)?.id
    return childId || '';
  })
